import { MouseEventHandler } from "react";

import clsx from "clsx";
import "./StartTrialButton.css";
import RoundedButton from "../../components/Button/RoundedButton";
import { ButtonVariant } from "../../lib/types";

type Props = {
  variant?: ButtonVariant;
  freeTrialActive: boolean;
  freeDays?: number;
  onClick: MouseEventHandler;
};
const StartTrialButton = ({
  variant = ButtonVariant.primary,
  freeTrialActive,
  freeDays,
  onClick,
}: Props) => {
  return (
    <div className="StartTrialButton">
      <div className={clsx("buttonWrapper", variant)}>
        <RoundedButton
          variant={variant}
          text={freeTrialActive && freeDays ? `Start ${freeDays}-day Free Trial` : "Subscribe"}
          onClick={onClick}
        />

      </div>
    </div>
  );
};
export default StartTrialButton;
